import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/layout/AppLayout';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import LandingPage from './pages/LandingPage';
import PricingPage from './pages/PricingPage';
import OnboardingPage from './pages/OnboardingPage';
import AdminWaitlistPage from './pages/AdminWaitlistPage';
import AdminTillyReportPage from './pages/AdminTillyReportPage';
import DashboardPage from './pages/DashboardPage';
import ProductDetailPage from './pages/ProductDetailPage';
import SeoInsightsPage from './pages/SeoInsightsPage';
import AutoGuardPage from './pages/AutoGuardPage';
import CleanupPage from './pages/CleanupPage';
import GoogleIntegrationsPage from './pages/GoogleIntegrationsPage';
import SettingsPage from './pages/SettingsPage';
import HelpPage from './pages/HelpPage';
import TillyWidget from './components/TillyWidget';
import { setupAxiosInterceptors } from './utils/axiosInterceptors';

setupAxiosInterceptors();
import MediaPage from './pages/MediaPage';
import LinksPage from './pages/LinksPage';
import YarnShopPage from './pages/YarnShopPage';
import AIBoostPage from './pages/AIBoostPage';
import HomeRedirect from './components/HomeRedirect';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<LoginPage registerMode />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {/* App (logged-in) */}
          <Route path="/app" element={<ProtectedRoute><AppLayout><DashboardPage /></AppLayout></ProtectedRoute>} />
          <Route path="/onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
          <Route path="/products" element={<Navigate to="/autoguard" replace />} />
          <Route path="/products/:id" element={<ProtectedRoute><AppLayout><ProductDetailPage /></AppLayout></ProtectedRoute>} />
          <Route path="/seo" element={<Navigate to="/app" replace />} />
          <Route path="/bulk" element={<Navigate to="/autoguard" replace />} />
          <Route path="/autoguard" element={<ProtectedRoute><AppLayout><AutoGuardPage /></AppLayout></ProtectedRoute>} />
          <Route path="/cleanup" element={<ProtectedRoute><AppLayout><CleanupPage /></AppLayout></ProtectedRoute>} />
          <Route path="/media" element={<ProtectedRoute><AppLayout><MediaPage /></AppLayout></ProtectedRoute>} />
          <Route path="/links" element={<ProtectedRoute><AppLayout><LinksPage /></AppLayout></ProtectedRoute>} />
          <Route path="/boost" element={<ProtectedRoute><AppLayout><AIBoostPage /></AppLayout></ProtectedRoute>} />
          <Route path="/garnbutikk" element={<ProtectedRoute><AppLayout><YarnShopPage /></AppLayout></ProtectedRoute>} />
          <Route path="/sync" element={<Navigate to="/app" replace />} />
          <Route path="/google" element={<ProtectedRoute><AppLayout><GoogleIntegrationsPage /></AppLayout></ProtectedRoute>} />
          <Route path="/insights" element={<ProtectedRoute><AppLayout><SeoInsightsPage /></AppLayout></ProtectedRoute>} />
          <Route path="/help" element={<ProtectedRoute><AppLayout><HelpPage /></AppLayout></ProtectedRoute>} />
          <Route path="/usage" element={<Navigate to="/settings" replace />} />
          <Route path="/settings" element={<ProtectedRoute><AppLayout><SettingsPage /></AppLayout></ProtectedRoute>} />
          <Route path="/admin/waitlist" element={<ProtectedRoute><AppLayout><AdminWaitlistPage /></AppLayout></ProtectedRoute>} />
          <Route path="/admin/tilly" element={<ProtectedRoute><AppLayout><AdminTillyReportPage /></AppLayout></ProtectedRoute>} />
        </Routes>
        <TillyWidget />
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
